
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/[slug]",
      function () {
        return require("private-next-pages/tutorials/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/[slug]"])
      });
    }
  